import React, { useState, useEffect } from 'react';
import AdvancedDataTable from '../DataTables/AdvancedDataTable';
import MobileDataTableCard from '../DataTables/MobileDataTableCard';
import Cell from '../DataTables/DataTableComponents/Cell';
import PropertyWidget from '../DataTables/DataTableComponents/PropertyWidget';
import FormSubmit from '../FormElements/FormSubmit';
import Tabs from '../Tabs/Tabs';
import PopopWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import RevenueReportingSummaryCard from '../Revenue/RevenueReportingSummaryCard';
import PrimaryButton from '../Buttons/PrimaryButton';

export default function RevenueReportingCard(props) {
	// console.log('RevenueReportingCard', props);

	const [
		showRevenueReportingSummaryCardPopup,
		setShowRevenueReportingSummaryCardPopup
	] = useState(false);
	const onClickShowRevenueReportingSummaryCardPopup = () =>
		setShowRevenueReportingSummaryCardPopup(
			!showRevenueReportingSummaryCardPopup
		);

	return (
		<div>
			<div className="contents lg:hidden">
				<MobileDataTableCard
					endpoint={props.get_properties_endpoint}
					rowRenderer={(row) => {
						// console.log('PropertiesCard - property row', row);
						let labels = [
							{
								displayName: 'Property',
								apiName: 'property_name',
								alignment: 'left'
							},
							{
								displayName: 'Revenue Source',
								apiName: 'nights_rented',
								alignment: 'center'
							},
							{
								displayName: 'Nights Rented',
								apiName: 'nights_rented',
								alignment: 'right'
							},
							{
								displayName: 'Gross Revenue',
								apiName: 'gross_revenue',
								alignment: 'right'
							},
							{
								displayName: 'Exempt Revenue',
								apiName: 'exempt_revenue',
								alignment: 'right'
							},
							{
								displayName: 'Taxable Revenue',
								apiName: 'taxable_revenue',
								alignment: 'right'
							}
						];
						return (
							<div key={row.id} className="p-6 bg-white border-t text-gray-800">
								<div>
									<PropertyWidget
										name={row.name}
										city={row.city}
										state={row.state}
										status={row.status}
									/>
								</div>
								<div className="my-4">
									<Tabs>
										<div label="Direct">
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[2].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[3].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[4].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<hr className="mt-4 border-1 border-gray-300" />
											<div className="mt-3 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[5].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
										</div>
										<div label="Airbnb">
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[2].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[3].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[4].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<hr className="mt-4 border-1 border-gray-300" />
											<div className="mt-3 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[5].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
										</div>
										<div label="Vrbo">
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[2].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[3].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[4].displayName}
												</span>
												<input
													className="ml-4 border border-gray-400 rounded py-1 px-2 text-sm w-20"
													type="text"
												/>
											</div>
											<hr className="mt-4 border-1 border-gray-300" />
											<div className="mt-3 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[5].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
										</div>
										<div label="Total" isTextBold={true}>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[2].displayName}
												</span>
												<span className="ml-12 text-sm">27</span>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[3].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
											<div className="mt-6 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[4].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
											<hr className="mt-3 border-1 border-gray-300" />
											<div className="mt-3 font-semibold">
												<span className="w-36 inline-block text-sm">
													{labels[5].displayName}
												</span>
												<span className="ml-12 text-sm">1000</span>
											</div>
										</div>
									</Tabs>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					// data={props.data}
					endpoint={props.get_properties_endpoint}
					style="text-gray-800 border-b-2 border-gray-300 font-semibold"
					columns={[
						{
							displayName: 'Property',
							apiName: 'property_name',
							alignment: 'left'
						},
						{
							displayName: 'Revenue Source',
							apiName: 'nights_rented',
							alignment: 'center'
						},
						{
							displayName: 'Nights Rented',
							apiName: 'nights_rented',
							alignment: 'right'
						},
						{
							displayName: 'Gross Revenue',
							apiName: 'gross_revenue',
							alignment: 'right'
						},
						{
							displayName: 'Exempt Revenue',
							apiName: 'exempt_revenue',
							alignment: 'right'
						},
						{
							displayName: 'Taxable Revenue',
							apiName: 'taxable_revenue',
							alignment: 'right'
						}
					]}
					rowRenderer={(row) => {
						// console.log('PropertiesCard - property row', row);
						return (
							<React.Fragment>
								<tr key={row.id} className="bg-white border-t text-gray-800">
									<td className="px-8 py-3 text-left">
										<PropertyWidget
											name={row.name}
											city={row.city}
											state={row.state}
											status={row.status}
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right" />
									<td className="pl-8 pr-6 py-3 text-right" />
									<td className="pl-8 pr-6 py-3 text-right" />
									<td className="pl-8 pr-8 py-3 text-right" />
									<td className="pl-8 pr-8 py-3 text-right" />
								</tr>
								<tr key={row.id} className="bg-white border-t text-gray-800">
									<td className="px-8 py-3 text-right" />
									<td className="px-8 py-3 text-center">Direct</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-8 py-3 text-right">
										<Cell value={1000} />
									</td>
								</tr>
								<tr key={row.id} className="bg-white border-t text-gray-800">
									<td className="px-8 py-3 text-right" />
									<td className="px-8 py-3 text-center">Airbnb</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-8 py-3 text-right">
										<Cell value={1000} />
									</td>
								</tr>
								<tr key={row.id} className="bg-white border-t text-gray-800">
									<td className="px-8 py-3 text-right" />
									<td className="px-8 py-3 text-center">Vrbo</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-6 py-3 text-right">
										<input
											className="border border-gray-400 rounded py-1 px-2 w-24"
											type="text"
										/>
									</td>
									<td className="pl-8 pr-8 py-3 text-right">
										<Cell value={1000} />
									</td>
								</tr>
								<tr
									key={row.id}
									className="bg-white border-t text-gray-800 font-semibold"
								>
									<td className="px-8 py-3 text-left" />
									<td className="px-8 py-3 text-center">Total</td>
									<td className="pl-8 pr-6 py-3 text-right"> 18</td>
									<td className="pl-8 pr-6 py-3 text-right">6000</td>
									<td className="pl-8 pr-6 py-3 text-right">1000</td>
									<td className="pl-8 pr-8 py-3 text-right">
										<Cell value={1000} />
									</td>
								</tr>
							</React.Fragment>
						);
					}}
				/>
			</div>
			<PopopWithUseClickOutside
				isPopupVisible={showRevenueReportingSummaryCardPopup}
				onHidePopup={onClickShowRevenueReportingSummaryCardPopup}
			>
				<RevenueReportingSummaryCard />
			</PopopWithUseClickOutside>
			<div className="grid">
				<div className="lg:justify-self-end mb-4 lg:mb-0">
					<PrimaryButton
						label="Report revenue"
						onClick={onClickShowRevenueReportingSummaryCardPopup}
					/>
				</div>
			</div>
		</div>
	);
}
